var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuElternInfo = function SvgMenuElternInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "20 20 54 52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menu_eltern-info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DB6830",
    d: "M67.64 59.102c-1.84 8.05-33.64 10.35-41.98 4.13s-5.98-31.58-1.66-37.91 22.2-5.24 22.44-5.24a35 35 0 0 1 17.07 3.14c8.58 4.08 5.97 27.85 4.13 35.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96027",
    d: "m53.27 65.482-5.84.29c-.67-.45-1.49-.35-2.22-.62a5 5 0 0 1-.7-.36c-1.8-1.24-3.12-.42-4.32 1-.58.08-1.16.08-1.75.11a26 26 0 0 1-8.24-.6c-1.08-.33-2.2-.53-2.87-1.7a3.86 3.86 0 0 1 4.35-2c4.61.76 9.11-.74 13.67-.34.957-.005 1.911.086 2.85.27a3.63 3.63 0 0 0 2.62-.35c1.31 0 2.43-.91 3.76-.87 1.59.55 3.71.19 4.26 2.5a2.16 2.16 0 0 1-.81 1.6c-1.44 1-3.26.36-4.76 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6229",
    d: "m67.34 29.772 1.36 3.4v1.17c-.4 1.4-.33 3.36-2.78 2.34a2.28 2.28 0 0 1-1.41-1.27c0-.52.45-.55.79-.63h-.22c-.7 0-1.32-.55-2-.2a2 2 0 0 1-1.45.22 1.73 1.73 0 0 0-1.63-.31c-1.21 0-2.73.73-3.12-1.27.22-.56.86-.51 1.24-.85a1.6 1.6 0 0 1-.77-.25 1.21 1.21 0 0 1-.48-1.46 4.9 4.9 0 0 1 1.85-1 10.8 10.8 0 0 1 2.46-.39c1.84-.3 3.67.28 5.51 0 .243.13.463.299.65.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F26",
    d: "M22.42 57.612a9.6 9.6 0 0 1-1.44-5c-.58-1.16.11-2.56-.66-3.7l-.08-1.75c1.47.21 3.19-2.58 4.45.36.29.68.09 1.59 1 2 1.09-.1.26-.89.46-1.31a2.25 2.25 0 0 1 2.49-1.44c1.27.36.69 1.61.51 2.49a5.06 5.06 0 0 1-2.42 3.11c-.91.12-.91 1.51-2 1.43-.51.07-1.15 0-.93.87.396.523.669 1.128.8 1.77-.13 1.44-.87 1.84-2.18 1.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6128",
    d: "m68.92 37.842.14 2.93c-.313.377-.78.59-1.27.58.45.18 1 .17 1.32.59v.58c-.54.55 0 1.35-.44 1.93-1.2.63-2.07-.28-3-.67s-2.06-1.14-3.25-.43c-.782.461-1.61.84-2.47 1.13-.389.11-.801.11-1.19 0a1.65 1.65 0 0 1-.85-.82 1.64 1.64 0 0 1 .5-1.45 9.6 9.6 0 0 0 1.59-1.64c1.67-.66 1.81-3.49 4.27-3 .15.36.32.69.69.13a3 3 0 0 1 .7-.3 4 4 0 0 1 3.26.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F26",
    d: "m20.1 44.252-.1-1.17q.255-.282.56-.51a4.8 4.8 0 0 1 1.44-.56c.391-.052.79-.008 1.16.13 2.84-.39 4.36 1.24 5.44 3.55-1 2-2.71.69-4.08 1-.57-.31-1.26-.45-1.63-1.05-.36-1.64-2.08-.48-2.79-1.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D05B23",
    d: "m23.07 45.282 1.22 1.11a.8.8 0 0 1 .06 1.17c-.47.22-1.78-3.1-1.53.37a.62.62 0 0 1-1.16.41c-.41-.52-.57-1.23-1.42-1.18l-.06-1.16c.82-.75 1.69-1.44 2.89-.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652D",
    d: "m68.92 37.842-4.08.19c-.34-1 .23-1.49 1.08-1.8 2 .89 2.18-.82 2.83-1.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96027",
    d: "m23.07 45.282-2.89.72-.08-1.75a4.4 4.4 0 0 1 3.28 0c1.16.52.41.84-.31 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35C24",
    d: "M69.11 41.932a3.85 3.85 0 0 1-3.67-1.28l3.62.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96027",
    d: "m45.68 65.842-3.5.17a.59.59 0 0 1 0-.77 3 3 0 0 1 2.82-.54c.38.31 1 .46.68 1.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M42.12 65.442q.045.284.06.57l-3.5.16a1.14 1.14 0 0 0-.13-.5l1.86-.26a1.24 1.24 0 0 1 1.71.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6E3A",
    d: "M20.32 48.912c1.09 1.08.62 2.44.66 3.7a.54.54 0 0 1-.49-.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D05B22",
    d: "m45.68 65.842-.68-1.14c.926-.01 1.812.38 2.43 1.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6C36",
    d: "M68.53 44.302c.14-.62 0-1.34.61-1.79l.14 2.92-.23.1-.23-.08-.32-.16a.89.89 0 0 1 .03-.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB642B",
    d: "M21 35.412a8.7 8.7 0 0 1 .81-3.55c1.68-.2-.31-1.41.5-1.86l.09-1.05a2.787 2.787 0 0 0 3.38-2.58c.66-.46 1.23-.18 1.79.22.62.62 1.51.79 2.2 1.3.11.94 1.16 1.12 1.54 1.85a1.1 1.1 0 0 1-.15.75c-.81 1.1-2 .53-3.06.75a3.1 3.1 0 0 1 1.32.09c1.61 2.4-.88 3.29-1.75 4.79-1.28.45-2.81 1.67-3.05-1 .22-.31-.1.08.13-.23q.16-.218.35-.41-.15.127-.27.28a2.9 2.9 0 0 1-3.83.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6933",
    d: "M48.85 20.582h1.13a3.65 3.65 0 0 0 2.02 1.19c1.15.31 2 1.26 3.28 1.35.15-2.48 2.15-.38 3-1.2a2.15 2.15 0 0 1 1.72.54c.42.1-.8 1.1.49.82.57-.13 1.07.33.71 1.09a1.83 1.83 0 0 1-1.54.45c-.76-.17-.74.29-.81.76-2.67.58-5.36.26-8 .25-.92-.4-1.93.25-2.86-.2a1.12 1.12 0 0 1-.43-1.09c1-.87-1-.69-.51-1.39.35-.89 1.58-1.16 1.61-2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "m21 35.412 3.92-.75c.07 3 2 .51 3 1l.36.08c.63.38 1.18.88 1.82 1.26a1 1 0 0 1 .36 1 1.8 1.8 0 0 1-1.36.86c-2.22.18-4.43-.29-6.66.23-1.77.42-1.91-.77-1.53-2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M34.07 21.272c2.51-.94 5.14-.68 7.73-.76.74.38 1.54 0 2.29.2.61.8.45 1.75.54 2.66a4.36 4.36 0 0 1-1.47 2.45c-.476.3-1.055.39-1.6.25-1.3-.51-2.43-1.53-4-.77-.84.39-1.17-.31-1.05-1.14a2.12 2.12 0 0 1 1.1-1.09c.33-.15.86-.22.92-.53.11-.65-.48-.3-.76-.36a2.8 2.8 0 0 0-2.05.59c-1.06.05-1.5-.56-1.65-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652D",
    d: "M20.87 37.042c.17.92 0 2 1.65 1.45a9.93 9.93 0 0 1 6.67.06.8.8 0 0 1 .26.7 3.4 3.4 0 0 1-.71 1.43c-.57.59-1.43 1.11-2 .5-1.13-1.23-2.43-.61-3.67-.7a4 4 0 0 1-.79-.05 3.3 3.3 0 0 1-1.74-.88 3.3 3.3 0 0 1 .33-2.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6A34",
    d: "m27.47 26.942-1.78-.5-.31-.18c-.38-.49-.75-.93-.38-1.57a7.34 7.34 0 0 1 4-2.33 4.9 4.9 0 0 0 2 1c.519.171.957.527 1.23 1 .24 1-.16 1.57-1.17 1.25-1.44-.46-2.34.3-3.25 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6730",
    d: "M58.25 21.912c-2.09 1.24-4.16 2.62-6.44.37-.4-.3-.9-.53-.77-1.17.79-.63 1.68.15 2.49-.18a10.1 10.1 0 0 1 4.72.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652E",
    d: "m32 24.382-1.19-.53c-.16-1.63 1.43-1.65 2.22-2.42l1-.16c.71.29 1 1.29 2 1.17 1.2-.65 1.76-.21 1.8 1.08l-1.14.64a.82.82 0 0 1-.69.28 3.37 3.37 0 0 0-3.27.13.75.75 0 0 1-.73-.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6830",
    d: "M25.69 26.442c1.61 1.2 0 2-.5 2.69-.89 1.39-1.88.31-2.8-.18l1.17-2.4a1.47 1.47 0 0 1 2.13-.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652D",
    d: "M67.34 29.772h-.56c-.64-.65-1.63-.35-2.33-.86a1 1 0 0 1-.25-.68c.07-1-1-1.5-1.27-2.34a1.3 1.3 0 0 1 0-.81c.35-.47.74-.81 1.38-.54a7.15 7.15 0 0 1 3.03 5.23M33.05 21.432c-.36 1.15-1.56 1.54-2.22 2.42-1.15.16-1.83-.19-1.83-1.49a9.6 9.6 0 0 1 4.05-.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE713F",
    d: "m64.33 24.532-1.27.72a6.3 6.3 0 0 1-2.94.57 1.57 1.57 0 0 1-1.12-.95c.45-1.3 1.57-.35 2.3-.7.23-.49.8-.29 1.13-.57.88-.29 1.4.3 1.9.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD6E3A",
    d: "M44.16 20.932c-.8-.09-1.67.28-2.36-.42a27.8 27.8 0 0 1 7.05.07l-.08.2c-1.51.89-3.03 1.45-4.61.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA652D",
    d: "M62.38 23.602a1.25 1.25 0 0 1-1.13.57c-.82-1-2.08-.21-3-.55.27-1.15 1.41-.48 1.81-1.16 1-.18 1.52.77 2.32 1.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96027",
    d: "M20.54 39.552c.62 0 1.27-.15 1.7.5a23 23 0 0 1-.47 2.36 1.18 1.18 0 0 1-1.29.59c0-1-.05-1.95-.07-2.92a1.1 1.1 0 0 1 .13-.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD6C37",
    d: "M22.3 30.002c0 1.54 2 .47 2.18 1.95-.89.51-1.8-.38-2.68-.09a2.11 2.11 0 0 1 .5-1.86M25.69 26.442l-2.13.11a3 3 0 0 1 1.44-1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6933",
    d: "M53.53 20.932c-.68 1.24-1.59 0-2.36.21-.5.18-.74.06-.61-.5a4.4 4.4 0 0 1 2.97.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D75E25",
    d: "m50.56 20.642.61.5c.21.38.42.76.64 1.14-1.29.19-1.9-.36-1.83-1.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45C23",
    d: "M27.34 63.242a2.3 2.3 0 0 1-1.76-1c-.39-1.94.64-2.53 2.28-2.2 1.07.21 2.06.69 2.79-.55.86-1.44 1.91-2.14 3.46-.88-.15 2.29 1.57 1.1 2.53 1.39 1.67.5.95-.76 1.09-1.38 1.09-1.31 2.2-1.28 3.29 0a3.26 3.26 0 0 0 1.49 1.15c.94.1 1.58-.75 2.47-.78a1.6 1.6 0 0 1 1.79 1.3c-.09.79-.92.93-1.28 1.48-3.21.28-6.42.65-9.64.81-2.85.12-5.76-.67-8.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96127",
    d: "M61.53 62.862a7.2 7.2 0 0 1-3.64 1.17l.52-1.13c1.26-1.24-1-2.1-.37-3.24a.43.43 0 0 1 .32-.29c-.13 0-.24.08-.34.27a1.87 1.87 0 0 1-2.49.52c-.73-.43-1.15-.07-1.66.31a2.25 2.25 0 0 1-2.81-1.24c-.08-.7.37-1 .91-1.23a7 7 0 0 0 2.19-.69 2.4 2.4 0 0 1 1-.43c.28 0 .66 0 .75.22.64 1.43.6 0 .83-.2.85-1.07 2.5-1.18 3.11-2.55.172-.198.383-.358.62-.47a.92.92 0 0 1 .73.22c1.26 1.2.31 2.43 0 3.65-.08 1.72-.45 3.44.33 5.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D05B24",
    d: "M58.24 59.402c-.56 1.2 3 2.2.17 3.5-.76-2-2.9-1.22-4.2-2.14-.21-.12-.28-.25-.22-.38s.13-.2.2-.2c-.53-1.17.12-1.57.92-.91 1.13.94 2.09.33 3.13.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D55D24",
    d: "M42.12 65.442h-1.71c-.19-1.13.38-2.06 1.38-2s2.73-.46 3.25 1.31a5 5 0 0 1-2.92.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5A23",
    d: "M45.49 61.772a1.06 1.06 0 0 1 1.11-1.22c.63-.81 1.35-1.3 2.39-.69.71 1 .37 1.74-.56 2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5A23",
    d: "M54.19 60.182v.58c-1.07.61-2.11 1.42-3.47.75a5.6 5.6 0 0 1-.35-1.86c.14-.4.34-.68.82-.5.97.48 1.81 1.33 3 1.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D24",
    d: "M50.66 59.772c.388.51.42 1.207.08 1.75-.41 1.43-1.48.66-2.31.69a3.87 3.87 0 0 0 .48-2.36l.21-.26a1.5 1.5 0 0 1 1-.19c.211.071.398.199.54.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96127",
    d: "m67.8 52.512.07 1.17a8.2 8.2 0 0 1-3.95 1c-.49-.84-1.11-1.09-1.94-.41a1.05 1.05 0 0 1-1.07-.24c-1.78 0-3.54-.46-5.33-.35a3.6 3.6 0 0 1-1.26-.06 1.5 1.5 0 0 1-.72-.49 1.7 1.7 0 0 1-.14-1.29 2.2 2.2 0 0 1 1.71-1.19 5.1 5.1 0 0 0 1.61-.58c1.35-.76 2.43-2.61 4.27-.32.61.77 2.51.38 3.31.45-.63.11-1.18-.39-1.16-1.54a2.28 2.28 0 0 1 3-1.34c.814.124 1.644.1 2.45-.07a5.3 5.3 0 0 1-1 4.09c-1.87.23-3.73.75-5.48.45a9 9 0 0 0 3.34-.07c.99-.11 1.79-.16 2.29.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D55F27",
    d: "M61.53 62.862c-2.24-1.4-.6-3.56-1-5.32.66-.29.89.23 1.18.62s.48 1 1.19.91c.32-.13.62-.29.92-.44 1.2-.41.72-1.2.42-1.94.22-2.93 2-1.63 3.38-1.21.05 4.18-2.29 6.39-6.09 7.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D75F26",
    d: "M68.68 47.232c-.72.38-.4 3.32-2.35.83-.61-.77-1.93-.18-2.75.56-1.17.12-1.06-.75-1.14-1.47 1.13-.68.38-2.69 2.1-3 1.46 0 2.9.1 4 1.3a.3.3 0 0 0 .3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D15C24",
    d: "M67.59 55.482c-.6 1.41-3-1.53-3 1.28.56 1.2-.19 1.82-1 2.39l-.56.61a.83.83 0 0 1-.64-.52.77.77 0 0 0-1.17-.56 1.2 1.2 0 0 0-.63-1.14c.5-1.13 1.21-2.24.41-3.53l1.17-.06c.63 0 1.16.43 1.78.5 1.31-.37 2.46-1.65 4-.77a2.12 2.12 0 0 1-.36 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD6C37",
    d: "M67.8 52.512c-1.88-.71-3.91-.08-5.83-.66 2 .16 3.71-1.51 5.74-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96027",
    d: "M31.37 60.092c-.81.88-1.74 1.72-2.93.86-1.79-1.29-2.32-.12-2.86 1.25a6.92 6.92 0 0 1-3-4c.35-.4.86-.28 1.3-.37 2-.44 1.32-1.21.26-2a2 2 0 0 1-1.22-1.12c.59-.38.59-1.56 1.7-1.24s.62-1.52 1.69-1.25c.45-.27.77 0 1 .29.43 1.38 1.54 1.14 2.53 1-.67-.19-1.64.42-2.13-.59-.28-.86.27-1.33.71-2 1.13-1.7 1.81-3.56-.13-5.27-.54-.82-2.4-.44-1.95-2.26.13-.52-.22-.69-1.33-.34-.94.3-1.83.89-2.14-.65a1.7 1.7 0 0 1-.11-2.33c1.33-.89 2.87.07 4.24-.49-.68 2.77.9.91 1.62.79h.41c.69.3 1.76.78 1.41 1.45-1 2 .42 2.63 1.52 3.54 1 .52-.18 2.34 1.46 2.5.51.42 1.1.78 1 1.57-.274.364-.68.604-1.13.67 0 .1-.61-.07-.1.28.31.2-.1-.07.29 0 .85.22 1.74.38 1.81 1.52-.15.64-.91.67-1.17 1.19a1.6 1.6 0 0 0-.46 1.19 2.8 2.8 0 0 1-.07 1.81 1.7 1.7 0 0 1-1.35.75c-1.1.05-2.67-1.63-3.12 0a3.7 3.7 0 0 1-2 2.77 3.8 3.8 0 0 1 1.94-.48 3.87 3.87 0 0 1 2.31.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD5923",
    d: "M24.15 55.772c1.46-.28 2 .79 2.92 2.2l-4.48.21-.17-.55c1.28.01 1.94-.52 1.73-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "m65.92 36.232-1.08 1.8c-.18.27-.37.29-.58 0-2.16 0-2.24 2.57-4 3.11-.58.58-1.45.54-2.08 1-.36.81-2.19 0-1.81 1.62a8.6 8.6 0 0 1-2.2 1.36l-2.14.21c-1.29-.67-2.79-.39-4.13-.87a2.4 2.4 0 0 1-.7-.36c-.36-.41-.66-.83-.24-1.38a3.2 3.2 0 0 1 1.72-.65.95.95 0 0 1 .54.13c.17-.4-.32-.39-.4-.64a26 26 0 0 1-1.11-2.79c.44-1.58 2-1.17 3-1.63.3-.12.65.16.9-.17a1.14 1.14 0 0 1-.8-.72 2.8 2.8 0 0 1 0-2c1.19-1.18 2.83-1.53 4.21-2.37.271-.045.549-.045.82 0 .56.29 1.39.36 1.13 1.34.48 1.81 2.2.07 3 1 .42.47 1.15.14 1.58.62 1.49 1.83 1.39 2.31-.64 2.69q-1.139.236-2.3.29c3.2.23 3.2.23 4.7-3.28.68-.26 1.07.09 1.38.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96127",
    d: "m56.89 30.772.64 1.14a1.39 1.39 0 0 1-1.75.08c-1.61-.15-2.77 1.15-4.54 1.08a5 5 0 0 1-4.43-2.3c.49-1.27 2.56-.13 2.78-1.82a1 1 0 0 1 .48-.56c.34-.16.86-.41 1.06-.23 1.68 1.56 2.32-.35 3.35-.95.25-.04.507-.008.74.09.54.3 1.19.22 1.75.49.52.47.75 1 .14 1.54-.66.44-.36.96-.22 1.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB642B",
    d: "M63.5 34.592c-.76 4.22-1.94 4.55-5.45 4-.53-.08-1.21.37-1.25-.53s.65-.79 1.22-.9a10 10 0 0 1 2.5-.51c3.41.32 1.29-1.05.65-2a.35.35 0 0 1 .58 0l1.14-.64c.61-.24.72.06.61.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M64.39 28.702c1-.1 1.9 0 2.39 1.06-1.71.84-3.52-.27-5.25.24a1.05 1.05 0 0 1-.32-.84c.064-.307.257-.573.53-.73a2.3 2.3 0 0 1 2.65.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "M56.89 30.772c-.55-.33-1.51-.33-1.49-1.14s.89-.49 1.41-.61c.29.23.68.21 1 .37.335.156.617.406.81.72-.4.74-1.09.66-1.73.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6C36",
    d: "M58.62 30.152a1.26 1.26 0 0 1-1.2-.53 1.82 1.82 0 0 1 1.71-1.24 2.92 2.92 0 0 1 2.37 1v.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "m55.78 32.032 1.75-.08c.46 0 1.31-.15 1.28.27-.06 1.06-1.09.81-1.81.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB662E",
    d: "M61.75 34.672h-.58c-.62.32-1.18.51-1.19-.53.5-.2.56-1.11 1.23-.92s.44.94.54 1.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D55D24",
    d: "m63.5 34.592-.61-.56c1.25-1.62 1.89.77 3 .45a1.22 1.22 0 0 1-1.14.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25C23",
    d: "M65.63 31.912a10.4 10.4 0 0 1-1.57.68c-.11 0-.49-.35-.47-.52a.69.69 0 0 1 .75-.69q.673.196 1.29.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D55D24",
    d: "M65.84 34.482c0-.45 0-1 .71-.91.15 0 .39.46.35.66-.15.76-.67.29-1.06.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D24",
    d: "m26.93 52.702-.61-.56c1.34-1.37 2.68-2.72 2.37-5.31-.51 1.06-3.09.18-1.34 2.51.42.56-.75.89-1.19 1.29s-1 .1-1.46-.36c-.77-.84-.45-1.78-.35-2.71l-.06-1.17c1.12-1.5 2.93.65 4.06-.78.76-.06 1.61-.19 1.48 1-.17 1.57 1.09 3.37-.57 4.67-.51.41-1.2.53-1.16 1.36a.796.796 0 0 1-1.17.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "M24.63 53.392c-.59.38-.79 1.3-1.7 1.24-.46-1.81.36-1.86 1.7-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D23",
    d: "M54.05 44.972a2.07 2.07 0 0 1 2.28-1.27 1.22 1.22 0 0 1 1.75-.08l.61.55c.33.53-.81 1.24.21 1.69.097.241.097.51 0 .75a1.8 1.8 0 0 1-.69.38 4.58 4.58 0 0 1-3-.95 3 3 0 0 1-1.16-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5A23",
    d: "M68.52 45.492c-1.23-.69-2.8-.07-4-1-.37-.59 0-1 .4-1.32a.59.59 0 0 1 .7.1l2.87 1c.04.43.03.82.03 1.22M58.77 45.922a2.08 2.08 0 0 1-2-1.28c.54-.65 1.54.62 1.95-.47h1.17c1 0 2.18-.08 2 1.52-.89 1.15-2.04.5-3.12.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D24",
    d: "M61.69 45.772c.05-1.28-1.39-.93-1.83-1.67l2.28-1.28c.68-.29 1.11.06 1.46.59a1.94 1.94 0 0 1-1.91 2.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB642B",
    d: "m58.08 43.622-1.75.08c-.73-1.78.86-1.45 1.67-1.83.6-.26.72 0 .61.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652D",
    d: "m63.33 43.372-1.19-.53c1.34-1.3 2.43-.44 3.52.42h-.57a1.31 1.31 0 0 1-1.76.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35C23",
    d: "m58.61 42.422-.61-.55c.57-.89 1.5-.58 2.3-.7a1.76 1.76 0 0 1-1.69 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25B23",
    d: "M63.18 41.212c-.435.5-1.168.61-1.73.26.49-.7 1.14-.19 1.73-.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35C23",
    d: "M64.25 38.062h.58c0 .51.24 1.13-.39 1.46-.1.06-.44-.1-.44-.13.06-.46.16-.89.25-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25C23",
    d: "M22.82 40.032c0 .77.07 1.55.11 2.33l-1.16.05c-1.19-1.05-.45-1.72.47-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "m30.32 37.912-.61-.55c-.74-.41-.62-1.77-1.83-1.67-.09-1.62 2.3-2.31 1.56-4.17 3.32-1.17 6.77-.86 10.19-.84a9.4 9.4 0 0 1 2.44 4c-1 .48-1.09 1.57-1.61 2.39a2.55 2.55 0 0 1-.95.8 2.55 2.55 0 0 1-1.26.19 1.6 1.6 0 0 1-1.46-1.29 2 2 0 0 1 0-.27 3 3 0 0 1 0-.29c-1.21.75-2.42 1.48-3.6 0-.23.27 0 .58-.1.87a1.65 1.65 0 0 1-2.78.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M39.94 31.032a69.5 69.5 0 0 1-10.5.49l-2.76.14c1.57-1.28 3.2-.75 4.45-1.39 2.23-.79 4.67-.08 6.89-1 1.038 0 2.074.081 3.1.24.73.09 1.77.27 1.68 1.14s-1.07.91-1.86.83a1.7 1.7 0 0 1-1-.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6127",
    d: "M38.13 29.942a10.5 10.5 0 0 1-7 .33v-.58c.153-.212.355-.384.59-.5q.363-.153.75-.23a8.57 8.57 0 0 1 4.21-.19q.4.03.79.12c.259.081.5.21.71.38a.54.54 0 0 1-.05.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M29.85 28.002c-.92-.07-2.12.49-2.38-1.06.55-1 1.37-1.8 2.54-1.33s.62 1.38.18 2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6A34",
    d: "M31.69 29.662h-.58c-.13-.78-3.71 1-1.26-1.69.38-.55.82-1.29 1.55-.7a1.92 1.92 0 0 1 .29 2.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "M24.91 34.662c.08-1.15.75-1.35 1.89-1-.28 1.09-1.16.95-1.89 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632B",
    d: "M38.13 29.942v-.58c.13-.63 1-.85.9-1.6a1 1 0 0 1 .41-.58 3.86 3.86 0 0 0 1.48-1c.145-.195.329-.359.54-.48l1.75-.08.2.34c.12.37-.11-.07.07.27.47.85.21 2.13 1.49 2.49-1.08-.34-.63-1.22-.68-1.92a1.76 1.76 0 0 1 .4-1.31c.51-.72-.56-2.34 1.31-2.2a5.1 5.1 0 0 1 1.8.93l.05 1.17c.42.65 1.19.41 1.75.68 1.64.78 1.36 1.75.17 2.74-.91.56-1.31 2-2.78 1.57-.08 0-.24-.06-.27 0-.2.27.18.2.21.34 2.57 1.54 5.17 2.66 8.05.65.07-.05.52.44.79.68-1.53.66-2.64 2.29-4.59 2a3.83 3.83 0 0 1-2.45.58c-1.35 0-2.81.51-3.89-.77l-.17-.15q.185.171.34.37c.11 2.72-1.43 1.88-2.84 1.33l-.29-.33c-.06-1.62-2.51-2.08-1.95-4l2.76-.13c-1.69-1.18-3.24-.49-4.56-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M49.78 28.772c.56-1.32.95-2.61-1.29-2.18-2 .37-.55-.77-.63-1.24.79.24 1.53-.68 2.34-.11 1.15 1.64 2.81.28 4.18.7.45.37.83.76.59 1.41a2.53 2.53 0 0 0-1.47 2.5c0 .41-.29 1-.89.86-.31-.07-.8-.51-.76-.69.58-2.53-1.42-.76-2.07-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632A",
    d: "M54.34 26.252a9 9 0 0 0-.85-.08c-1.17 0-.09 2.7-1.83 1.7-.7-.4-.23-2.11-1.46-2.59l8.8-.41 1.19.52c.09.1.17.21.25.31-.05.257-.183.489-.38.66-.65.39-1.19 1-2 1-.24-.68-.66-.88-1.31-.46q-.976-.405-2-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "m44.16 20.932 4.61-.16c1.88 2.45-.72 1.77-1.6 2.3a5 5 0 0 0-1.87.34 1 1 0 0 1-1.05-.2 1.8 1.8 0 0 1-.09-2.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M45.41 23.162c.55-.77 1.14-.8 1.76-.08-.06.53 1.2.33.64 1.14l-1.81-.45c-.16-.26-.54-.26-.59-.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6831",
    d: "m30.32 37.912 1.17-.05c.42.31 1 .56.7 1.25a2 2 0 0 1-1.08.52q-.41.045-.82 0a1.56 1.56 0 0 1-1.08-.53v-.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45C23",
    d: "M27.88 35.692c1.78-.73 1.46.86 1.83 1.67-1.14.03-1.37-.94-1.83-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB642C",
    d: "M41.44 25.692v.59c-.68.56-2 .05-2.28 1.27-.71.47-.92 1.4-1.66 1.84h-.59a3.63 3.63 0 0 0-4.67.22h-.58c-1-.11.58-3.09-1.83-1.67-.27-.67.88-1.47 0-1.93s-1.68.39-2.43.88c.53-2.05 1.65-2.93 3.75-1.91.71.35.76-.15.8-.65h.59c1.13-.72 2.31-.45 3.5-.17h.58c.07.36.22 1 .6.68 1.83-1.31 3.07-.56 4.22.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6128",
    d: "M37.83 23.522a1.76 1.76 0 0 0-1.83-1.08c-.1-.4-.47-1.22.16-1 1.22.33 2.37-.21 3.95-.07-.8.95-.63 2.4-2.28 2.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD6D39",
    d: "m45.41 23.162.59.61c-.5.17-1.29.18-.62 1 .18.23.9 0 .62.56-.1.2-.7.15-1.07.21a1.28 1.28 0 0 1-1.76.08c-.13-1 .77-1.57 1.06-2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB642B",
    d: "M40.85 22.982a.78.78 0 0 1 1-.69c.51.07.95.35 1 .88s-.52.7-1 .7a.848.848 0 0 1-1-.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D86026",
    d: "m29.21 39.132 1.17-.05c.11 1.34-.45 1.75-1.7 1.25a1.24 1.24 0 0 1 .53-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD6F3C",
    d: "M36.11 24.192a5.26 5.26 0 0 1-3.5.17c1.07-1.99 2.28-1.15 3.5-.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M63.09 25.842c.45.74 2.64.51 1.28 2.27l-.37-.07a1.75 1.75 0 0 1-1.12-1.88q.097-.165.21-.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D55E24",
    d: "m64.39 28.702-2.91.14c-1.56-.64-.19-1.15.18-1.29a3.26 3.26 0 0 1 2.71.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M60.17 25.972v-.58c1-.14 1.91-.91 2.92-.14v.59a2.07 2.07 0 0 1-2.92.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D75F25",
    d: "m32.38 56.532 1.14-.64c1.24-1.56 3.07-.63 4.57-1.07a2.67 2.67 0 0 1 1.7 1c1 1.19 2.72 1.57 3.46 3.07a2.49 2.49 0 0 1-.73 1.88c-.57-.35-1.5-.6-1.63-1.07-.56-2.1-1.87-1.42-3.15-1l-.33-.1c-.95.07-1.91.11-2.86.14q-.15.074-.31.12c-1.21-.11-2.79-1-2.87 1.31a3.9 3.9 0 0 1-2.37-.56c.37-1.84 2-2.35 3.38-3.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "M50.66 59.772h-.59c-.4-.4-.8-.5-1.16 0l-2.31.7a1.76 1.76 0 0 0-1.8-1.09.53.53 0 0 1-.2-.42c0-.17 0-.25.07-.25a5.4 5.4 0 0 1 1.59-.92c.45-.22.54-.73.83-1.08a2.26 2.26 0 0 1 1.75-.34q.323.06.63.18c.5.14.76-.05.78-.58 0-.74-.22-1.73.89-1.82a1.73 1.73 0 0 1 2 1.58 5 5 0 0 1-.13 1.23 2.7 2.7 0 0 1-.7 1.48c-.473-.03-.92.221-1.14.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6027",
    d: "M37.74 58.622q.466.534 1 1c.39.3.87.54.52 1.12s-.76.46-1.25.25a3.56 3.56 0 0 0-2.77-.36c-.73.27-1.58 1.41-2.25.38s1.23-1.24 1.25-2.24a4.62 4.62 0 0 1 3.5-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6128",
    d: "M44.77 58.872v.58c-.77.37-1.23 1.32-2.25 1.32 0-.64-.17-1.33.5-1.78a1.21 1.21 0 0 1 1.75-.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D75E25",
    d: "M55.6 53.092a6 6 0 0 1 5.31.92l-.55.61c-1 1-3.46 0-3.39 2.5-.5 1.82-1.18-.14-1.76.08-.47-.38-1.12-.55-1.4-1.16-.53-1.67.67-2.27 1.79-2.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5A23",
    d: "M57 57.122c-1.26-1.39-.63-2.2.89-2.53a11 11 0 0 1 2.5 0c-.33 1.99-2.24 1.77-3.39 2.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D75E25",
    d: "m52.35 58.512-.08-1.74c1.41-1 1.88.06 2.39 1-.57.93-1.5.62-2.31.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5A23",
    d: "M54.66 57.772c-1 .14-1.18-1.62-2.39-1l.55-.61a.78.78 0 0 1 1.18-.07 1.06 1.06 0 0 1 1.22 1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D23",
    d: "m58.24 59.402.19-1.31c.22.1.57.15.64.31.35.82-.3.87-.83 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96127",
    d: "M48.91 59.842c-.09-.39-.6-.92.15-1.09s.93.44 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "m55.25 45.512 3 1c.3.94-.44 1.18-1 1.43s-1.42-.12-.25.86c.91.77-.08 1.47-1 1.7-.2.11-.46-.45-.65 0a.512.512 0 0 1 .26.77c-.64 0-1.33 0-1.72.67a.83.83 0 0 1-.93.28.32.32 0 0 1-.22-.34q-.16.23.12.36c-.11.88.9.36 1.08.86h.59c-.21 1.46-1.39 1.38-2.27 1.12a3.28 3.28 0 0 0-2.63.46c-.63-.08-.88-.56-1.13-1.05-.21-.92-.84-1.11-1.67-.95-1.08.18-1.27-1.16-2.19-1.26a5 5 0 0 1-2.66-2.87c-.25-.85-1-2 .28-2.5 1-.38 2.5.18 2.55 1.23.11 2.39 1.41 1 2.28 1 .382-.043.768.002 1.13.13.6.27 1.17.78 1.89.3a9.4 9.4 0 0 1 1.59-.71c.55-1.67 1.52-2.85 3.55-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35C23",
    d: "M55.46 50.172c.42-.2 1.12-.32 1.21-.61.23-.8-.63-.76-1.09-1s-1.36-.12-1.09-1 .85-.73 1.57-.25c.95.64 1.57-.14 2.16-.79h.58c1.29 1 2.83-.6 4.12.39 0 .64 0 1.33.66 1.72.36 1.84 1.92.73 2.85 1.16-3.41 1.72-6.81 1.37-6.75-1-1.51.83-2.44 2.42-4.16 2.56l-1.22-1.12a.783.783 0 0 1 1.16-.06M49.24 54.562c1.3-2.08 3.79.26 5.2-1.41l1.16-.06a5.75 5.75 0 0 0-1.61 3l-1.17.06c-.11-1.08-.9-1.34-1.93-1.53l.21 2.15a1.29 1.29 0 0 1-1.75.09.86.86 0 0 1-.33-.59 3.33 3.33 0 0 1 .22-1.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D55D23",
    d: "M63.86 54.452c-.92 1-1.49.73-1.78-.5 0-1 .62-1.38 1.46-1.14s.12 1.1.32 1.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "M52.63 52.062h1.17l.05 1.16c-.73 0-1.8.35-1.22-1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "M61.13 58.682c.87-.7.44-2.36 1.92-2.58 1.24 1.26-1.16 2.4-.11 3.66-1.44 1.01-1.24-.67-1.81-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6026",
    d: "m63.5 59.152 1-2.39c.74.37 1.45.85 1 1.77s-1.28.48-2 .62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "M62.92 46.902c-1.32-.69-3 2.8-4.12-.39v-.59c.93-1.09 2 .32 2.92-.13.6-.78 1.58-1.29 1.64-2.42l1.76-.08c-.18.4-.36.79-.53 1.19-1.17.4-.72 1.89-1.67 2.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D23",
    d: "M33.16 48.312c-.61-.72-1.48.6-2.13-.43 0-.8 1.86-1.2.82-2.44l.3-.26a12.8 12.8 0 0 1 6.61-.2q.525.501.92 1.11c.46.52 1 1.07.52 1.79s-1.16.53-1.83.31c-.5-.15-.93.19-1.41.27-1.23-1.01-2.57.7-3.8-.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6229",
    d: "M33.16 48.312c1.54.17 1.78-1 1.87-2.16 1.37.2.74 2.19 2.21 2 1.11-.18.47.65.61 1 .07.55.48 1 .31 1.63a5.55 5.55 0 0 1-1.95 1.75 1.1 1.1 0 0 1-1.11-.22c0-1.28-1.39-.92-1.83-1.67-.43-1.13.88-.69 1.11-1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45C23",
    d: "M32.38 56.532c-.77 1.42-2.2 2.11-3.37 3.08-1-.08-2 .37-3.28-.2 1-1 4.85-.47 1.85-3.33-.38-.37.52-.81.88-.76 1.36.19 2.93-.21 3.92 1.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632A",
    d: "m35.1 52.312 1.17-.06c.53-.75 1.06-1.21 1.49.08-.09.72.51 1 .93 1.37.46.71-.36.92-.54 1.39-1.34 1.43-3.18 0-4.63.8-.23-.57-.45-1.15-.67-1.72.34-.44.88-.68 1.11-1.22-.08-1.03.49-.91 1.14-.64M28.68 40.332a1.76 1.76 0 0 0 1.7-1.25h.59c.5.67 1.51.4 2 1.09-.48 1.74-.74 3.53-1.13 5.29-1.81.61-1.66-2.06-3.53-1.79 2.04-1.18 1.82-2.25.37-3.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "m26.93 52.702 1.17-.06c.82 1.26 2.9-.39 3.42 1.59-1.34-1.14-3.73 1.09-4.59-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D15B23",
    d: "m34.38 49.422-1.11 1.22-1.64 1a2.51 2.51 0 0 1 2.75-2.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M34 52.952c.17.9.17.9-1.11 1.22a1.06 1.06 0 0 1 1.11-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632B",
    d: "m39.66 37.472.56-.61a.93.93 0 0 1 .7-.29c1.95.26 3.87-.53 5.82-.08 1.55.72 3-.95 4.56-.15 1 .41.4-1.57 1.47-1 .22.13.49.42.48.63 0 .86-.58 1.2-1.38 1.53-1.29.55-2.84.28-4 1.3a1.72 1.72 0 0 1-.49 1.11 3 3 0 0 1-2 1c-1.45 0-1.44-.74-.7-2-.93 1.13-1.72 2.34-3.23 1.27a2.9 2.9 0 0 1-1.36-1.34c.67-.66-.99-.64-.43-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35C23",
    d: "M48.38 48.772h-1.16a.7.7 0 0 1-.29-.59 1.77 1.77 0 0 0-.28-1.6 2.23 2.23 0 0 1-.49-1.38 1.37 1.37 0 0 1 1.42-1.12c1.6.16 3.42-.71 4.72.94.049.97-.289 1.92-.94 2.64a3.43 3.43 0 0 0-2.61 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "m47.58 44.122-1.11 1.22c-1.46.33-3 1.46-4.29-.27 2.39-4 2.39-4 6.17-3.07l.31.31c-.39.7-1.08.62-1.72.67a.79.79 0 0 1-1.22.1c.54.49 1.3.57 1.86 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5A23",
    d: "m51.24 47.452 1.06-2.39a1.56 1.56 0 0 1 1.75-.09c.47-.064.936.146 1.2.54-1.11.73-3.09.7-2.37 3 .15.47-.6.49-1 .08-.25-.21-.59-.3-.81-.57a.47.47 0 0 1 .17-.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D65E24",
    d: "M51.3 36.342c-1.53.32-2.88 1.73-4.64.8-.16-1.25.94-1.42 1.6-1.42 2 0 .14-1.19.6-1.61.79.25 1.53-.67 2.33-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D25C23",
    d: "m47.36 39.452.55-.62c1.39.53 1.25 1.74 1.31 2.87a.7.7 0 0 1-.82.12c-1.26-.39-1.76-1.12-1.04-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB662E",
    d: "M52.72 41.532c.29-.22.56-.58.88-.62.76-.09 1.29-1.86 2-.71s-.65 1.61-1.66 1.86c-.33-.39-.94-.12-1.22-.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "M48.63 41.772h.59l1.35.23c-.11.35-.1.82-.34 1-.85.73-1-.56-1.57-.64-.15-.12-.21-.25-.16-.38s.08-.21.13-.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6831",
    d: "M52.77 42.702c.44.07 1 0 1.28.27s-.2.64-.56.74c-.84.24-1.2-.21-1.3-1a.35.35 0 0 1 .58-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652E",
    d: "M47.58 44.112a2.25 2.25 0 0 1-1.91-.8l1.27-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45C23",
    d: "M52.77 42.702h-.58c-.75-.81.18-.88.53-1.2.466-.072.932.135 1.19.53a1.21 1.21 0 0 0-1.14.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M54.74 38.242c-.17-.29-.39-.5-.36-.67s.27-.38.43-.57c.15.17.44.35.43.5s-.24.41-.5.74M46.94 30.702c-.7-.16-1.3.88-2.1.16.39-1.06 1.16-1 2.06-.85.67.09 1.59.34 1.5-1 0-.65.57-.73 1.38-.2.43.78 1.74 1.83-.56 1.79-.76-.02-1.52.06-2.28.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "M56.69 26.772c.62-.32 1.18-.5 1.2.53q.265.208.56.37c.35.38 1 .59.69 1.32l-1.72.68-.61-.56c.63-.42 0-.78-.06-1.16-.61-.58-1.14.52-1.75.07v-.58l-.63-1.14c.92-.76 1.57.11 2.32.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6933",
    d: "M55 27.972c.58 0 1.12-1.26 1.75-.07-.57.17-1.13.97-1.75.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632A",
    d: "m59.14 28.942-1.22-1.11c.74-.63 1.54-1.19 2.25-1.86l2.92-.13c0 1 .91 1.48 1.28 2.27-.84-.05-1.68-.16-2.51-.13-.47 0-1 .25-.38.86v.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632B",
    d: "m32.13 39.002-.64-1.14a1.057 1.057 0 0 0 1.11-1.22 6.7 6.7 0 0 0 4.67-.22 1.08 1.08 0 0 0 1.23 1.11c.29.73-.11 1.14-.66 1.5-1.91.43-3.84 1.21-5.71-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D23",
    d: "M37.27 36.422a3.002 3.002 0 0 1-4.67.22c.1-.7-.39-1.53.54-2.16.55.71.17 2.24 1.73 2 1-.13 1.62-.45 1.36-1.63-.1-.51.32-.7.73-.5 1.04.54.14 1.42.31 2.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB662E",
    d: "M32 32.772c1.08-.88 1.93-.12 2.76-.32a25 25 0 0 1 2.79-.33 5.37 5.37 0 0 1-5.55.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45C23",
    d: "M40.8 36.832h-.58c.3-.84-.18-2.39 1.67-1.83.27 1.01.27 1.83-1.09 1.83"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6831",
    d: "m38 38.772.53-1.19 1.16-.06c-.05.53 1.2.33.64 1.14a1.68 1.68 0 0 1-1.14.59 1.49 1.49 0 0 1-1.19-.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6A34",
    d: "M32.27 29.632c1.47-1.95 3-2 4.67-.22a10.7 10.7 0 0 0-4.67.22M37.53 29.392c1-.21-.88-3 1.66-1.84 2.7 2.44-1 1-1.08 1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "m40.8 36.832 1.09-1.8c.87-.61 3.06 1.67 2.86-1.31 1.31.75 2.79-.25 4.11.39l1.33 1.48-3.53 1.55c-1.91-.85-3.99 1.52-5.86-.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6933",
    d: "m43.19 25.612 1.81-.08c.11 1.19-.94 2.87 1.45 3.1-1.8 1.07-2.42-.32-3.44-1.2s.29-1.21.18-1.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M39.19 27.552c.09-.67-.83-1.46.08-2s1.29 1 2.2.74c-.12 1.56-1.37 1.11-2.28 1.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "M44.75 33.772c-.71 0-1.52.25-2-.82 1-.37 1.75-.49 2 .82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6932",
    d: "M60.17 25.972c-.11 1.4-1.19 1.61-2.25 1.86v-.58c.6-.66 1.15-1.48 2.25-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.69 26.772-2.36-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D86026",
    d: "m38 38.772 1.16-.05c.75 1.46-.45 1.58-1.31 1.93q-.495.093-1 .12a12.5 12.5 0 0 1-3.29-.09 4.3 4.3 0 0 1-.8-.49c-.85.05-1.69.1-1.8-1.08l1.16-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "M34.26 25.422c.84.12 2-.35 2.07.91 0 .9-.9 1.39-1.86 1.41s-1.88-.41-1.91-1.33 1.05-.83 1.7-.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "M48.63 41.772v.58c-3.43.1-3.43.1-6.31 2.64a4.17 4.17 0 0 0 .25 5.21c.59.54 1.17.93 1.07 1.81-.36 1.13-1.24.9-1.94.84a1.56 1.56 0 0 0 2.3-1.21c.26-.35.56-.61 1-.38 1.05-.38.76 1.45 1.81 1.08 1.3-.29 1.13.86 1.47 1.51a1.8 1.8 0 0 1-.57 1c-1.1.54-1.3 1.85-2.2 2.56a1.38 1.38 0 0 1-1.88-1c-.13-1-.79-1-1.62-.93s-1.62 1-2.62.68l-1.23-1.11c-.63-.76.64-.67.53-1.2a10.5 10.5 0 0 1-1.23-1.08c0-1-.57-.85-1.19-.53-.17-1.27 1.3-1 1.66-1.83.57-1.44-1-.49-1.22-1.11s1.17-.44.53-1.2c.59-1.91 1.71.47 2.64-.51.32-.93-2.13-1.17-1-2.49q.138-.132.26-.28c.63-1 1.82-1.58.85-3.18-.65-1.09.79-1.46 1.56-1.93.56-.15 1.82 1.88 1.72-.71 0-.79 2.09.81 3-1.11.13 1.85-1.63 1.27-1.44 2.51 1.09.28 1.7-.69 2.56-1-.22 1.15.61 1.7 1.24 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45C23",
    d: "M39.38 56.202c.93-1.5 2.53-1.41 4-1.55.85-.09 1.07.56.71 1.33-.79 1.24 0 1.55 1 1.59.62 0 1.15 0 1.43.63-.39.71-1.08.62-1.72.67l-1.8.08c-1.24-.86-2.72-1.41-3.62-2.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652C",
    d: "m37.74 58.622-3.5.16c0-.36-.32-1.29.15-.93 1.09.84 2.61-1.01 3.35.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96127",
    d: "M46.49 58.202a7.2 7.2 0 0 1-2.42-.38c-.71-.38-1.94-1.21 0-1.84.11 1.18 1 1.13 1.8 1.08a.81.81 0 0 1 1.17 0c.31.57.48 1.12-.55 1.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD5923",
    d: "M47 57.012h-1.17c-.78-1.71.42-2.07 1.64-2.42a10.8 10.8 0 0 1 1.83 1.67v.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.35 56.902 1.75-.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D45D24",
    d: "M43.27 51.922c-2.11-1.28-2.25-3.36-2.34-5.53-.05-1.16.37-1.54 1.42-1.44 1.26 1.32 2.86-1 4.12.39l.64 1.14c0 .58.44 1.15.08 1.75v.58c-1.26.82-3.77 1.28-3.31-.18.85-2.74-1.4-1.25-1.56-2.15-.21 2.29 1.2 3.56 2.68 4.78l-.55.61a.788.788 0 0 1-1.18.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "M49.32 56.312c-1.28.19-1.9-.36-1.83-1.67l.56-.61c.13-.25.2-.55.55-.61a1.2 1.2 0 0 1 .64 1.14c.18.58.99 1.13.08 1.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "m48.6 53.422-.55.61-1.25-1.69c1.27-.76 2.1-.77 1.8 1.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D35C23",
    d: "m51.27 48.032.61.56-1.72.67c-.67.18-.79-.25-.85-.76.45-.98 1.16-.94 1.96-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB642C",
    d: "m49.55 48.702.61.56c-.92 1-1.49.72-1.78-.51a.8.8 0 0 1 1.17-.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6730",
    d: "m55.46 50.172-1.16.06c-.6-.59-.08-.88.37-1 .64-.1.72.47.79.94M52.63 52.062l-1.31-.18c.1-.22.15-.57.32-.64.81-.36.86.3 1 .82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D96026",
    d: "M36.85 39.942h.59c2.47 1.18 3 2.9 1.41 5.19l-7 .33a.9.9 0 0 0 0-.28 5.4 5.4 0 0 1 .92-5h.58a3.48 3.48 0 0 0 3.5-.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D15B23",
    d: "M36.71 49.312a2.513 2.513 0 0 1 2.95 2l-1.73-.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M37.46 52.772a1.06 1.06 0 0 1 1.22 1.11c-.61-.11-1.63.17-1.22-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632A",
    d: "M38.85 45.112a.9.9 0 0 1 0-.28 5.38 5.38 0 0 0-1.38-4.91c.84 0 1.69-.06 1.69-1.25l1.17-.06 1.19 1.16c-.3 1-2.41 2.35 1 2.91-1.88.42-1.87 2.55-3.67 2.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D85F25",
    d: "M49.55 48.702h-1.17c.78-.81.93-3 2.86-1.3v.58c-.61.1-1.3.02-1.69.72M47.19 48.232c-.18-.58-1-1.13-.08-1.75 1.2.52 1.23 1.11.08 1.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB632A",
    d: "M36.85 39.942c-.12.6-.09 1.79-.93 1.22s-2.61 1.26-2.57-1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6832",
    d: "M43.27 51.922h1.17c-.45.74-.5 2.07-1.92 1.44-1-.44-1.63.68-2.72.69.52-2.28 2.78-.79 3.47-2.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB652C",
    d: "M34 43.912a1.6 1.6 0 0 1 2.61-.14 1.61 1.61 0 0 1-2.61.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m48.2 33.342-.77 2.3-1.86 1.35-1.74.25-1.33-.19-1.52-.81-.92-1.22-.39-1.86.23-1.28.89-1.44 1.07-.76 2.13-.42 1.52.24 2.18 1.77zM46.8 52.772l.13-11.29h-1.21l-2.88-.21-1.16-.11-3.32-.23.09 4.74 3.24-.11c0 2.22.06 4.75.05 7.21h-3.3v4.76l12.76-.21v-4.55z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "menu_eltern-info_svg__a",
    width: 93.504,
    height: 90.786,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    xmlns: "http://www.w3.org/2000/svg",
    in: "SourceGraphic",
    stdDeviation: 1.717
  }), /*#__PURE__*/React.createElement("feOffset", {
    xmlns: "http://www.w3.org/2000/svg",
    dx: 2,
    dy: 2,
    result: "pf_100_offsetBlur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    xmlns: "http://www.w3.org/2000/svg",
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    xmlns: "http://www.w3.org/2000/svg",
    in2: "pf_100_offsetBlur",
    operator: "in",
    result: "pf_100_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    xmlns: "http://www.w3.org/2000/svg",
    in: "SourceGraphic",
    in2: "pf_100_dropShadow"
  })))));
};
export default SvgMenuElternInfo;